import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AdminForm from './forms/AdminForm';
import AdministratorsForm from './forms/AdministratorsForm';
import AdminSteps from '../common/AdminSteps';
import { browserHistory } from 'react-router';
import * as runActions from '../../actions/runsActionCreators';
import * as profileActions from '../../actions/profileActionCreators';
import { Row, Col, Table } from 'react-bootstrap';
import label from '../../utils/lngEn';
import * as utils from '../../utils/utils';
import ConfirmDeleteModal from '../common/ConfirmDeleteModal';

class ProfileAdmin extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      showConfirmAdminDelete: false,
      customTitleDelete: '',
      deleteAdminId: ''
    };

    this.handleSubmitAdmins = this.handleSubmitAdmins.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleDeleteAdmin = this.handleDeleteAdmin.bind(this);
    this.changeAssign = this.changeAssign.bind(this);
    this.closeDeleteModal = this.closeDeleteModal.bind(this);
  }
  componentWillMount() {
    this.props.runActions.getRun();
    this.props.runActions.getRuns(1);
    this.props.profileActions.getDeans();
  }
  showDeleteModal(id, admin) {
    this.setState({ deleteAdminId: id });
    this.setState({ customTitleDelete: admin });
    this.setState({ showConfirmAdminDelete: true });
  }
  closeDeleteModal() {
    this.setState({ showConfirmAdminDelete: false });
  }
  handleDeleteAdmin() {
    let id = this.state.deleteAdminId;
    this.props.profileActions.deleteDean(id).then(() => {
      this.props.profileActions.getDeans();
      this.setState({ showConfirmAdminDelete: false, customTitleDelete: '', deleteAdminId: '' });
    });
  }

  handleSubmitAdmins = values => {
    this.props.profileActions.addAdmin(values.admins).then(() => {
      this.props.profileActions.getDeans();
    });
  };

  handlePasswordChange = values => {
    this.props.profileActions
      .changePassword(values)
      .then(() => {
        console.log('PASSWORD CHANGED');
      })
      .catch(() => {
        console.log('PASSWORD NOT CHANGED');
      });
  };

  changeAssign(slug) {
    localStorage.setItem('run', slug);
    browserHistory.push('/administer/' + slug + '/assignment');
  }

  render() {
    const { assignment_complete } = this.props.run;
    return (
      <div className="col-md-12">
        <div className="page-title">Profile</div>
        <AdminSteps active="-1" label={this.props.run.slug} assignment_complete={assignment_complete} />
        <Row>
          <Col md={8}>
            <div className="page-subtitle">Account Information</div>
            <div>
              <label>Username</label>
              <span className="username">{utils.getUser()}</span>
              <AdminForm onSubmit={this.handlePasswordChange} />
            </div>

            <div className="page-subtitle">Select Active Assignment Period</div>
            <div className="c-table">
              <Table condensed hover>
                <thead>
                  <tr>
                    <th />
                    <th>Name</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.runs.map((run, index) => {
                    return (
                      <tr key={index} className={run.slug == localStorage.getItem('run') ? 'active' : ''}>
                        {/*<td className="assign-icon"><i className="fa fa-check-circle-o" onClick={()=>{this.changeAssign(run.slug)}}></i></td>*/}
                        <td className="assign-icon">
                          <a href={`/administer/${run.slug}`}>
                            <i className="fa fa-check-circle-o" />
                          </a>
                        </td>
                        <td className="assign-name">
                          <a href={`/administer/${run.slug}`}>{run.slug}</a>
                        </td>
                        <td className="assign-desc">{run.longname}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
            <div className="page-subtitle">Frequently Asked Questions</div>
            <div className="faq-q">{label.q1}</div>
            <p className="faq-a">{label.a1}</p>
            <div className="faq-q">{label.q2}</div>
            <p className="faq-a">{label.a2}</p>
            <div className="faq-q">{label.q3}</div>
            <p className="faq-a">{label.a3}</p>
            <div className="faq-q">{label.q4}</div>
            <p className="faq-a">{label.a4}</p>
            <div className="faq-q">{label.q5}</div>
            <p className="faq-a">{label.a5}</p>
            <div className="faq-q">{label.q6}</div>
            <p className="faq-a">{label.a6}</p>
            <div className="faq-q">{label.q7}</div>
            <p className="faq-a">{label.a7}</p>
          </Col>
          <Col md={4}>
            <div className="sidebar-container">
              <div className="sidebar-header">{localStorage.getItem('run')} Administrators</div>
              {this.props.profile.deans
                .filter(dean => {
                  return dean.user.email != localStorage.getItem('email');
                })
                .map((dean, index) => {
                  return (
                    <div className="dean-row" key={index}>
                      {dean.user.email}{' '}
                      <span className="pull-right">
                        <i
                          className="fa fa-minus-circle"
                          onClick={() => {
                            this.showDeleteModal(dean.id, dean.user.email);
                          }}
                        />{' '}
                      </span>
                    </div>
                  );
                })}
              <AdministratorsForm onSubmit={this.handleSubmitAdmins} />
            </div>
          </Col>
        </Row>
        <ConfirmDeleteModal
          closeModal={this.closeDeleteModal}
          showModal={this.state.showConfirmAdminDelete}
          onCancel={this.closeDeleteModal}
          customTitle={this.state.customTitleDelete}
          customMsg={label.deleteAdminCustomMsg}
          confirmButtonTitle="Delete"
          onConfirm={this.handleDeleteAdmin}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    run: state.run,
    profile: state.profile,
    runs: state.runs
  };
}

function mapDispatchToProps(dispatch) {
  return {
    runActions: bindActionCreators(runActions, dispatch),
    profileActions: bindActionCreators(profileActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileAdmin);



// WEBPACK FOOTER //
// ./src/components/profile/ProfileAdmin.js